import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";

import BaseIntro from "./BaseIntro";
import _str from "shared/util/_str";
import _strf from "shared/util/_strf";
import SanitizedText from "shared/components/SanitizedText";
import Essay from "apps/messenger/components/Connections/shared/Essay";
import Compatibilities from "apps/messenger/components/Connections/shared/Compatibilities";
import FadedScrollableText
	from "apps/messenger/components/Connections/shared/FadedScrollableText";

import { LikedVia } from "apps/messenger/components/Connections/constants";

import "apps/messenger/components/Connections/Postmatch/Intro.scss";

function Intro({
	onClose,
	targetUser,
	myThumb,
	onMessageEdit,
	sendMessage,
	draft,
	likedEssay,
	likedPhoto,
	likedVia,
}) {
	const {
		connection_compatibilities: connectionCompatibilities = [],
	} = targetUser;

	const displayname = get(targetUser, "userinfo.displayname", "them");

	const headerCopy = _strf("You matched with $name!", { name: displayname });

	const theyIntrod = !!(
		targetUser.last_contacts &&
		targetUser.last_contacts.threadid &&
		targetUser.first_message &&
		targetUser.first_message.body
	);

	let subtitleCopy = null;

	if (theyIntrod) {
		subtitleCopy = _str("They introduced themselves");
	} else if (likedVia === LikedVia.GLOBAL) {
		subtitleCopy = _str("Send them a message");
	} else {
		subtitleCopy = _str("Comment on this");
	}

	return (
		<div className="postmatch-intro-edit">
			<BaseIntro
				header={headerCopy}
				subtitle={subtitleCopy}
				onClose={onClose}
				targetUser={targetUser}
				onMessageEdit={onMessageEdit}
				sendMessage={sendMessage}
				draft={draft}
				myThumb={myThumb}
				theyIntrod={theyIntrod}
			>
				{!theyIntrod &&
					<React.Fragment>
						{!!connectionCompatibilities.length && likedVia === LikedVia.GLOBAL &&
							<Compatibilities>
								{ connectionCompatibilities }
							</Compatibilities>
						}

						{
							likedVia === LikedVia.PHOTO &&
							<div
								className="prematch-intro-edit-photo"
								style={{
									backgroundImage: `url(${likedPhoto})`,
								}}
							/>
						}

						{
							likedVia === LikedVia.ESSAY &&
							<div className="postmatch-intro-edit-content">
								<Essay
									{...likedEssay}
								/>
							</div>
						}
					</React.Fragment>
				}

				{
					theyIntrod &&
					<div className="postmatch-intro-edit-intro">
						<FadedScrollableText>
							<SanitizedText
								className="postmatch-intro-edit-intro-content"
								text={targetUser.first_message.body}
							/>
						</FadedScrollableText>
					</div>
				}
			</BaseIntro>
		</div>
	);
}

Intro.propTypes = {
	onClose: PropTypes.func.isRequired,
	targetUser: PropTypes.shape({
		connection_compatibilities: PropTypes.array,
		last_contacts: PropTypes.shape({
			threadid: PropTypes.number,
		}),
		first_message: PropTypes.shape({
			body: PropTypes.string,
		}),
	}).isRequired,
	likedEssay: PropTypes.shape({
		title: PropTypes.string.isRequired,
		clean_content: PropTypes.string.isRequired,
	}),
	onMessageEdit: PropTypes.func.isRequired,
	sendMessage: PropTypes.func.isRequired,
	draft: PropTypes.string.isRequired,
	likedVia: PropTypes.oneOf(Object.values(LikedVia)),
	likedPhoto: PropTypes.string,
	myThumb: PropTypes.string.isRequired,
};

Intro.defaultProps = {
	likedEssay: {},
	likedPhoto: "",
	likedVia: LikedVia.GLOBAL,
};

export default Intro;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/Postmatch/Intro.jsx